import { cn } from '@/utils';
import { isMobile } from '@/utils/mobile.util';
import { FunctionComponent, memo, useCallback, useRef, useState } from 'react';

import AppUseInfoPopup from '.';
import { AppUserInfoPopupProps, IProps } from './app-use-info-popup.type';

const AppUseInfoPopupButton = (props: AppUserInfoPopupProps) => {
	const { label = '추가', isWithdrawn = false, ...rest } = props;

	const [open, setOpen] = useState(false);

	const appUseInfoPopup = useRef<FunctionComponent<IProps>>();

	const onOpenModal = useCallback(() => {
		if (!appUseInfoPopup.current) {
			appUseInfoPopup.current = AppUseInfoPopup;
		}

		setOpen(true);
	}, []);

	const onCancel = useCallback(() => {
		setOpen(false);
	}, []);

	return (
		<div className="flex flex-1 items-center justify-between">
			<p
				className="cursor-pointer text-blue10 py-[5px] h-[30px] px-[11px] text-[13px] underline"
				onClick={onOpenModal}
			>
				{label}
			</p>

			{isWithdrawn && (
				<label
					className={cn(
						'xl:h-4 block text-[13px] text-font3 leading-[15.5px]',
						isMobile && 'text-font2 text-[13px] md:text-[14px]'
					)}
				>
					{'탈퇴 요청'}
				</label>
			)}

			{appUseInfoPopup.current && (
				<appUseInfoPopup.current {...{ ...rest, open, onCancel }} />
			)}
		</div>
	);
};

export default memo(AppUseInfoPopupButton);
